import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCategoryWithFilter, fetchQuizeWithPage } from "../../../slices/thunks";
import { ConfirmPopup } from "../Confirmation";
import { quizeColumnsConfig } from "../config/Quiz";
import axios from "axios";
import { toast } from "react-toastify";
import { api } from "../../../config"

export const getQuizeColumns = ({ onDeleteClick, onEditClick }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [quizDetails, setQuizDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sharePopupQuizId, setSharePopupQuizId] = useState(null);

  const handleCopy = async (quizId) => {
    try {
      // Start the quiz and get the token
      console.log(api.API_URL);
      const startResponse = await axios.post(`${api.API_URL}api/start/${quizId}`);
      console.log(startResponse);
      if (startResponse.status === 200) {
        const token = startResponse.data?.token;
        if (token) {
          // Generate the candidate form URL with token
          const baseUrl = window.location.origin;
          const quizLink = `${baseUrl}/candidate-form/${token}`;
          
          // Copy the URL to clipboard
          await navigator.clipboard.writeText(quizLink);
          
          // Show success message
          toast.success("Quiz link copied to clipboard!", {
            position: "top-right",
            autoClose: 3000,
          });
        } else {
          toast.error("Failed to generate quiz token");
        }
      } else {
        toast.error("Failed to start quiz");
      }
    } catch (error) {
      console.error("Error generating quiz link:", error);
      toast.error("Failed to generate quiz link");
    }
  };

  useEffect(() => {
    dispatch(getCategoryWithFilter())
      .then((res) => {
        const list = Array.isArray(res.payload?.data) ? res.payload.data : [];
        setCategories(list);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setCategories([]);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchQuizeWithPage())
      .then((res) => {
        const quizData = Array.isArray(res.payload?.data?.data?.data)
          ? res.payload.data.data.data
          : [];

        const newQuizDetails = {};
        quizData.forEach((quiz) => {
          try {
            // const categoriesData = quiz.category_data
            //   ? JSON.parse(quiz.category_data)
            //   : [];
            const categoriesData = typeof quiz.category_data === "string"
  ? JSON.parse(quiz.category_data)
  : quiz.category_data || [];
  console.log(categoriesData);

            newQuizDetails[quiz.quiz_id] = {
              name: quiz.name,
              description: quiz.description,
              categories: categoriesData,
              quizLink: quiz.quiz_link,
              timeLimit: quiz.time_limit,
            };
          } catch (error) {
            console.error("Error parsing category_data:", error);
          }
        });

        setQuizzes(quizData);
        setQuizDetails(newQuizDetails);
      })
      .catch((err) => {
        console.error("Error fetching quizzes:", err);
      });
  }, [dispatch]);

  const getCategoryName = (category_id) => {
    const category = categories.find((cat) => cat.id === category_id);
    return category ? category.name : null;
  };

  const getQuizInfo = (quiz_id) => {
    const quiz = quizDetails[quiz_id] || {
      name: "Loading...",
      description: "Loading...",
      categories: [],
      quiz_link: "Loading...",
      time_limit: "Loading...",
    };

    const formattedCategories = quiz.categories
      ?.map((category) => getCategoryName(category.category_id))
      .filter(Boolean)
      .join(", ") || "No Categories";

    return { ...quiz, formattedCategories };
  };

  const handleEditClick = (row) => {
    navigate("/quiz/add-form", { state: { id: row.quiz_id } });
  };

  return [
    {
      name: <span className="font-weight-bold fs-13">{quizeColumnsConfig.NAME}</span>,
      
      selector: (row) => row.name,
    
      sortable: true,
      // width: "10%",
    },
    // {
    //   name: <span className="font-weight-bold fs-13">{quizeColumnsConfig.QUIZEDESCRIPTIION}</span>,
    //   selector: (row) => row.description,
    //   sortable: true, 
    //   width: "40%"
    // },
    {
      name: <span className="font-weight-bold fs-13">{quizeColumnsConfig.CATEGORYDATA}</span>,
      selector: (row) => {
        const quiz = getQuizInfo(row.quiz_id);
        return quiz.formattedCategories;
      },
     
      sortable: true,
      width: "40%",
    },
 
    {
      name: <span className="font-weight-bold fs-13">{quizeColumnsConfig.TIMELIMIT}</span>,
      selector: (row) => row.time_limit,
      // width: "10%",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{quizeColumnsConfig.ACTION}</span>,
   

      cell: (row) => (
        <div className="d-flex align-items-center gap-2 justify-content-center">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleEditClick(row);
            }}
            className="fs-13 nav-link"
          >
            <i className="ri-edit-2-fill fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle"></i>
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setConfirmOpenForId(row.quiz_id);
            }}
            className="fs-13 nav-link"
          >
            <i
              className="ri-delete-bin-7-fill fs-16 p-2 bg-soft-danger rounded-circle align-middle icon-red"
            ></i>
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setSharePopupQuizId(row.quiz_id);
            }}
            className="fs-13 nav-link"
          >
            <i className="ri-share-fill fs-16 p-2 bg-soft-success text-success rounded-circle align-middle"></i>
          </a>

          {confirmOpenForId === row.quiz_id && (
            <ConfirmPopup
              message={quizeColumnsConfig.messages}
              setConfirmOpen={() => setConfirmOpenForId(null)}  
              onConfirm={() => {
                onDeleteClick(row.quiz_id);
                setConfirmOpenForId(null);
              }}
            />
          )}
          {sharePopupQuizId === row.quiz_id && row.quiz_link && (
            <div
              className="position-absolute translate-middle-x bg-white p-4 border border-gray-300 rounded-4 shadow-lg popup"
              style={{
                zIndex: "1000000",
                width: "280px",
                maxWidth: "90vw",
                height: "auto",
                left: "0px",
                top: "-100px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <div className="d-flex justify-content-end mb-2">
                <i
                  className="ri-close-line fs-5 text-muted cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => setSharePopupQuizId(null)}
                  title="Close"
                ></i>
              </div>

              <p className="fw-bold fs-6 mb-3 text-center" style={{ color: "#333" }}>
                📤 Share this Quiz
              </p>

            
              <button
                className="btn btn-outline-secondary d-flex justify-content-center align-items-center gap-2 rounded-3 w-100"
                style={{ padding: "8px 12px", fontSize: "14px" }}
                onClick={() => handleCopy(row.quiz_id)}
              >
                <i className="ri-links-fill"></i> Generate & Copy Link
              </button>
            </div>
          )}
        </div>
      ),
      // width: "10%",
    },
  ];
};









